export default __webpack_public_path__ + "static/Continuous Integration 4-69302d0edf94c292b7c97e4f0dfaf622.png";